module.exports = __webpack_public_path__ + "static/media/pin.0cd843b3.svg";